import React, { useState, useMemo } from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { CSVLink } from 'react-csv';
import useApiContext from 'hooks/useApiContext';
import useModalContext from 'hooks/useModalContext';
import { useLocation, Outlet, Link, useNavigate } from 'react-router-dom';
import { format, isAfter } from 'date-fns';
import useRepo from 'hooks/useRepo';
import { T, O, M, A } from 'TOMA';
import { useTranslation } from 'react-i18next';
import s from './UserEventList.module.scss';
import {
  Box,
  TextField,
  InputAdornment,
  CircularProgress,
  Chip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PlaceIcon from '@mui/icons-material/Place';

import {
  PaginationState,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getExpandedRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
  Visibility,
} from '@tanstack/react-table';
import { Switch } from 'components/Switch';
import { CustomLink } from 'components/CustomLink';
import { get } from 'http';

const columnHelper = createColumnHelper<any>();

function UserEventList(): JSX.Element {
  const { pathname } = useLocation();
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const { codificationRepository, exhibitorEventRepository } = useApiContext();
  const [filterCollectif, setFilterCollectif] = useState<any>();
  const [filterName, setFilterName] = useState<any>();
  const [reload, setReload] = useState<number>(0);
  const { setModalContent, setModalVisible } = useModalContext();

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOfferClick = (eventId: string): void => {
    // Dynamically import OfferPopup component
    import('../OfferList/OfferPopup').then((module) => {
      const OfferPopup = module.default;
      setModalContent(<OfferPopup eventId={eventId} isModal={true} />);
      setModalVisible(true);
    });
  };
  const {
    response = [],
    loading,
    error,
  } = useRepo(
    async () => await exhibitorEventRepository.getExhibitorEvents(),
    [reload]
  );

  const { response: codifCollectif } = useRepo(
    async () => await codificationRepository.get('collectif')
  );

  const columns = useMemo(
    () => [
      // columnHelper.accessor("status", {
      //   header: "Status",
      //   cell: (info) => {
      //     const val = info.getValue();
      //     return (
      //       <div className={s.ExhibitorList__status} data-key={val}>
      //         {val}
      //       </div>
      //     );
      //   },
      // }),
      // columnHelper.accessor("visibility", {
      //   header: "Visibility",
      //   enableSorting: false,
      //   cell: ({ getValue }) => {
      //     const { value, eventId } = getValue();
      //     return (
      //       <Switch
      //         key={eventId}
      //         checked={value}
      //         onChange={async (e) =>
      //           await eventRepository.mergeEvent("visibility", e, eventId)
      //         }
      //       />
      //     );
      //   },
      // }),
      // columnHelper.accessor('visibility', {
      //   header: t('event:participer'),
      //   enableSorting: false,
      //   cell: ({ getValue }) => {
      //     const { value, exhibitorEventId } = getValue();
      //     return (
      //       <Switch
      //         checked={value}
      //         onChange={async (e) => {
      //           try {
      //             console.log(e);
      //             const data = {
      //               visibility: e,
      //             };
      //             console.log(data);
      //             await exhibitorEventRepository.mergeExhibitorEvent(
      //               exhibitorEventId,
      //               data
      //             );
      //             return true;
      //           } catch (error) {
      //             console.error(error);
      //             return false;
      //           }
      //         }}
      //       />
      //     );
      //   },
      // }),
      columnHelper.accessor('name', {
        header: t('event:name_of_the_event'),
        enableSorting: false,
        cell: ({ getValue }) => {
          const { exhibitorEventId, value, year, eventId } = getValue();
          return (
            <CustomLink
              to={`${pathname}/event-registration/${exhibitorEventId}`}
              color="info"
            >
              <div
                className={s.ExhibitorList__status}
                data-key={exhibitorEventId}
              >
                {value} {year}
              </div>
            </CustomLink>
          );
        },
      }),
      columnHelper.accessor('contact', {
        header: t('event:contact'),
        enableSorting: false,
        cell: ({ getValue }) => {
          const { value, eventId, collectif, collectif_isset } = getValue();
          return (
            <div className={s.ExhibitorList__status} data-key={eventId}>
              {collectif_isset ? collectif : value}
            </div>
          );
        },
      }),
      columnHelper.accessor('date', {
        header: t('event:date'),
        enableSorting: false,
        cell: (info) => {
          const val = info.getValue();
          return (
            <div className={s.ExhibitorList__status} data-key={val}>
              {val ? new Date(val).toLocaleDateString('en-GB') : ''}
            </div>
          );
        },
      }),
      columnHelper.accessor('country', {
        header: t('event:country'),
        enableSorting: false,
        cell: (info) => {
          const val = info.getValue();
          return (
            <div className={s.ExhibitorList__status} data-key={val}>
              {val}
            </div>
          );
        },
      }),
      columnHelper.accessor('Dossier', {
        header: t('event:dossier'),
        enableSorting: false,
        cell: ({ getValue }) => {
          const { exhibitorEventId } = getValue();
          // const [visible, setvisible] = useState(false);
          return (
            <div>
              <CustomLink
                to={`${pathname}/event-registration/${exhibitorEventId}`}
                color="info"
              >
                {t('event:edit')}
              </CustomLink>
              {''}
            </div>
          );
        },
      }),
      columnHelper.accessor('Offer', {
        header: t('event:offers'),
        enableSorting: false,
        cell: ({ getValue }) => {
          const { eventId } = getValue();
          return (
            <div>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleOfferClick(eventId);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#0066cc',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                {t('event:offers')}
              </button>
            </div>
          );
        },
      }),
    ],
    []
  );

  const data = useMemo(() => {
    // Convert object to array if needed
    let responseArray: any[] = [];
    if (Array.isArray(response)) {
      responseArray = response;
    } else if (response && typeof response === 'object') {
      // Convert object with numeric keys to array
      responseArray = Object.values(response);
    } else {
      console.warn('Response is not an array or object:', response);
      return [];
    }

    if (responseArray.length === 0) {
      return [];
    }

    if (filterName) {
      const search = filterName.toLowerCase();
      responseArray = responseArray.filter((e) => {
        const name = e.event_name || '';
        const country = e.event_country || '';
        const contact = [e?.event?.contact_email_1, e?.event?.contact_email_2]
          .filter(Boolean)
          .join(', ');
        return (
          name.toLowerCase().includes(search) ||
          country.toLowerCase().includes(search) ||
          contact.toLowerCase().includes(search)
        );
      });
    }

    return responseArray.map((e) => {
      return {
        // status: e.status,
        visibility: {
          value: !!e.visibility,
          exhibitorEventId: e.id,
        },
        date: e.event_date,
        country: e.event_country,
        name: {
          value: e.event_name,
          eventId: e.event_id,
          exhibitorEventId: e.id,
          year: e.event?.year || '',
        },
        contact: {
          value: [e?.event?.contact_email_1, e?.event?.contact_email_2]
            .filter(Boolean) // This filters out any null or undefined values
            .join(', '),
          eventId: e.event_id,
          collectif: e.collectif_email,
          collectif_isset: !!e.collectif,
        },
        url: {
          eventId: e.event_id,
        },
        showroom: {
          value: e.showroom,
          exhibitorEventId: e.id,
        },
        Dossier: {
          exhibitorEventId: e.id,
        },
        Offer: {
          eventId: e.event_id,
        },
      };
    });
  }, [response, codifCollectif, filterCollectif, filterName]);

  const table = useReactTable({
    // data: data.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize),
    data,
    columns,
    state: {
      sorting,
      // pagination,
    },
    // pageCount: Math.ceil(data.length / pageSize) || 1,
    manualPagination: true,
    // onPaginationChange: setPagination,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    // getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', px: { xs: 2, md: 4 }, py: 4 }}>
      {/* Page header */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ fontSize: '22px', fontWeight: 700, color: '#111' }}>
          {t('event:list_of_events')}
        </Box>
        {!loading && (
          <Box sx={{ fontSize: '13px', color: '#888', mt: 0.5 }}>
            {data.length} événement{data.length !== 1 ? 's' : ''}
          </Box>
        )}
      </Box>

      {/* Search */}
      <Box sx={{ mb: 3 }}>
        <TextField
          size="small"
          fullWidth
          placeholder={t('event:events')}
          onChange={(e) => setFilterName(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 18, color: '#999' }} />
              </InputAdornment>
            ),
            sx: { borderRadius: '8px', fontSize: '13px', bgcolor: '#fff' },
          }}
          sx={{ maxWidth: 320 }}
        />
      </Box>

      {/* Loading */}
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress size={28} sx={{ color: '#000' }} />
        </Box>
      )}

      {/* Empty state */}
      {!loading && data.length === 0 && (
        <Box
          sx={{ textAlign: 'center', py: 8, color: '#aaa', fontSize: '14px' }}
        >
          {t('event:no_events_found') || 'Aucun événement trouvé'}
        </Box>
      )}

      {/* Event cards */}
      {!loading && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {table.getRowModel().rows.map((row, index) => {
            const nameCell = row
              .getAllCells()
              .find((c) => c.column.id === 'name');
            const dateCell = row
              .getAllCells()
              .find((c) => c.column.id === 'date');
            const countryCell = row
              .getAllCells()
              .find((c) => c.column.id === 'country');
            const dossierCell = row
              .getAllCells()
              .find((c) => c.column.id === 'Dossier');
            const offerCell = row
              .getAllCells()
              .find((c) => c.column.id === 'Offer');
            const contactCell = row
              .getAllCells()
              .find((c) => c.column.id === 'contact');
            const nameVal = nameCell?.getValue() as any;
            const isFirst = false;

            return (
              <Box
                key={row.id}
                component="a"
                href={`${pathname}/event-registration/${nameVal?.exhibitorEventId}`}
                sx={{
                  bgcolor: isFirst ? '#000' : '#fff',
                  borderRadius: '12px',
                  p: { xs: 2, md: 2.5 },
                  border: isFirst ? 'none' : '1px solid #eee',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: 'wrap',
                  transition: 'box-shadow 0.15s',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: 'inherit',
                  '&:hover': {
                    boxShadow: isFirst
                      ? '0 4px 16px rgba(0,0,0,0.25)'
                      : '0 4px 12px rgba(0,0,0,0.1)',
                  },
                }}
              >
                {/* Event info */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box
                    sx={{
                      fontSize: '15px',
                      fontWeight: 600,
                      color: isFirst ? '#fff' : '#111',
                      mb: 0.5,
                    }}
                  >
                    {`${nameVal?.value ?? ''} ${nameVal?.year ?? ''}`.trim()}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 2,
                      fontSize: '12px',
                      color: isFirst ? 'rgba(255,255,255,0.6)' : '#888',
                      flexWrap: 'wrap',
                    }}
                    component="div"
                  >
                    <>
                      {dateCell?.getValue() && (
                        <span>
                          📅{' '}
                          {new Date(
                            dateCell.getValue() as string
                          ).toLocaleDateString('fr-FR')}
                        </span>
                      )}
                      {countryCell?.getValue() && (
                        <span>📍 {countryCell.getValue() as string}</span>
                      )}
                    </>
                  </Box>
                </Box>

                {/* Actions */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    flexShrink: 0,
                    alignItems: 'center',
                  }}
                >
                  {dossierCell && (
                    <Box sx={{ fontSize: '13px' }}>
                      {flexRender(
                        dossierCell.column.columnDef.cell,
                        dossierCell.getContext()
                      )}
                    </Box>
                  )}
                  {offerCell && (
                    <Box sx={{ fontSize: '13px' }}>
                      {flexRender(
                        offerCell.column.columnDef.cell,
                        offerCell.getContext()
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}

export default UserEventList;
